import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bfb6ed6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "thumbnail-wrapper",
    style: _normalizeStyle({ 'background-image': `url('${_ctx.imagePath}')` })
  }, [
    _createElementVNode("span", { innerHTML: _ctx.title }, null, 8, _hoisted_1),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSlider && _ctx.openSlider(...args))),
      type: "button"
    }, "더보기")
  ], 4))
}